import React from 'react';
import heroVideo from '../projectitems/hero.mp4';
import heroPoster from '../projectitems/hero2.jpeg';
import weberLogo from '../projectitems/weberlogo.png';

const Hero = () => {

    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) {
            const top = el.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <section className="hero" id="home">
            <div className="hero__bg" style={{ backgroundImage: `url(${heroPoster})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <video
                    src={heroVideo}
                    className="hero__video"
                    autoPlay
                    loop
                    muted
                    playsInline
                    poster={heroPoster}
                />
                <div className="hero__overlay" />
            </div>

            <div className="hero__content">
                <p className="hero__eyebrow">HAYALLERİNİZİN MİMARİ İMZASI</p>
                <h1 className="hero__title">
                    <span className="hero__title-arth">ARTH</span>
                    <span className="hero__title-yapi">YAPI</span>
                </h1>
                <p className="hero__subtitle">
                    Mekanlarınıza estetik, fonksiyonel ve<br />özgün çözümler sunuyoruz.
                </p>
                <div className="hero__actions">
                    <button className="btn btn--gold" onClick={() => scrollTo('#urunler')}>ÜRÜNLERİMİZ</button>
                    <button className="btn btn--outline" onClick={() => scrollTo('#iletisim')}>İLETİŞİM</button>
                </div>
            </div>

            <a href="https://www.tr.weber/" target="_blank" rel="noopener noreferrer" className="hero__partner">
                <img src={weberLogo} alt="Weber" className="hero__partner-logo" />
            </a>

            <div className="hero__scroll">
                <span>Aşağı Kaydır</span>
                <div className="hero__scroll-line" />
            </div>
        </section>
    );
};

export default Hero;
